<template>
  <div class="calendar">
    <div class="container defaultheading">
      <h1>Karanteenin kuvakalenteri</h1>
    </div>
    <div class="container">
      <h3>Mistä on kyse</h3>
      <p class="content">Joka päivä 1.-24.12 Karanteenissa avautuu uusi jouluinen rakennus.</p>
      <p class="content">Pelaajana tehtäväsi on etsiä rakennuksista nappi ja painaa sitä. Vastaa annettuun kysymykseen oikein ja voitat palkinnon! Jos "avaat" jokaisen 24. rakennuksen luukun, saat uuden palikan taikamattoon!</p>
      <p class="content">Luukkuja voi avata päivään <strong>28.12.2019</strong> asti, jonka jälkeen kaikki luukut lukittuvat.</p>
      <p
        class="content"
      >Jokaista avautunutta rakennusta vastaan aukeaa täällä yksi kuvaluukku. Kuvaluukkujen takaa löytyy päivään liittyviä kuvia, sekä mahdollisia vinkkejä tai tietoiskuja.</p>
      
      <p class="content">Kurkista luukkujen taakse, niin saat tietää mitä Karanteenissa tapahtuu.</p>
    </div>

    <div class="calendar-content">
      <div v-if="loading" class="loading">
        <BouncingLoader />
      </div>
      <div v-if="error" class="error">{{ error }}</div>
      <div v-if="loaded" class="calendar-data">
        <div class="doorsLeft">
          <h3>{{doorsLeft}} luukkua jäljellä</h3>
        </div>

        <div v-for="(i, index) in 24" :key="'calendarDoor' + (index + 1)" class="passthrough">
          <CalendarDoor
            v-if="loaded[index].initiallyclosed"
            initiallyclosed
            :doornumber="index+1"
            :year="defaultCalendarYear"
            :month="defaultCalendarMonth"
          />
          <CalendarDoor
            v-else
            open
            :doornumber="index+1"
            :message="loaded[index].message ? loaded[index].message : 'Sieltä se joulu tulla tupsahtaa'"
            :heading="loaded[index].heading ? loaded[index].heading : 'Sieltä se joulu tulla tupsahtaa'"
            :image="loaded[index].filename ? loaded[index].filename : require('@/assets/128.png')"
            :year="loaded[index].year"
            :month="loaded[index].month"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CalendarDoor from "@/components/CalendarDoor.vue";

export default {
  name: "Joulukalenteri",
  components: {
    CalendarDoor
  },
  data() {
    return {
      loading: false,
      loaded: null,
      error: null,
      doorsLeft: 24,
      defaultCalendarYear: 2019,
      defaultCalendarMonth: 12
    };
  },
  created() {
    this.fetchOpenedCalendarDoors();
  },
  methods: {
    fetchOpenedCalendarDoors() {
      this.error = null;
      this.loading = true;

      axios
        .get(".netlify/functions/doorsPassed")
        .then(response => {
          this.loading = false;
          let doorsLeft = 0;
          let calendarDoorData = [];
          for (let i = 0; i < 24; i++) {
            let doorForGivenDay = response.data.filter(
              door => parseInt(door.day) === i + 1
            )[0];

            if (doorForGivenDay) {
              if (doorForGivenDay.month) {
                this.defaultCalendarMonth = doorForGivenDay.month;
              }
              if (doorForGivenDay.year) {
                this.defaultCalendarYear = doorForGivenDay.year;
              }
              calendarDoorData.push(doorForGivenDay);
            } else {
              let closedDoor = { initiallyclosed: true };
              calendarDoorData.push(closedDoor);
              doorsLeft++;
            }
          }
          this.loaded = calendarDoorData;
          this.doorsLeft = doorsLeft;
        })
        .catch(e => {
          this.loading = false;
          this.error = e;
          let calendarDoorData = [];
          for (let i = 0; i < 24; i++) {
            let closedDoor = {
              closed: true,
              doornumber: i + 1,
              initiallyclosed: true
            };
            calendarDoorData.push(closedDoor);
            this.loaded = calendarDoorData;
          }
        });
    }
  }
};
</script>
<style scoped>
.passthrough {
  display: inline;
}

.doorsLeft {
  margin: 1em 0;
  margin-left: 1em;
  flex-basis: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.doorsLeft h3 {
  font-size: 3em;
  margin: 0;
}

.doorsLeft h4 {
  font-size: 1.2em;
  margin: 0;
  font-weight: 500;
}

.calendar-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4em calc(1em + 4vw);
  background-color: hsla(222, 32%, 93%, 1);
  margin-top: 4em;
  padding-top: 1.5em;
  margin: 4em 0;
  align-items: center;
  box-shadow: inset 0px 2px 5px 0 rgba(0, 0, 0, 0.06),
    inset 0px -2px 1px 0px rgba(0, 0, 0, 0.06);
}

.calendar-data {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: 3em;
  overflow: hidden;
  max-width: 1800px;
  align-items: start;
}

@media screen and (max-width: 800px) {
  .calendar-data {
    font-size: 0.8em;
    justify-content: space-between;
  }
  .passthrough {
    flex: 1 1 auto;
  }
}
</style>